module.exports = __webpack_public_path__ + "img/globeIcon.7eb8ad60.png";